import { ROUTES } from '@shared/config/routes'

/**
 * Границы шкалы. В контракте они живут в схеме OpenAPI (`minimum`/`maximum` у
 * `score`), в ответах не приходят, поэтому держим константой в одном месте:
 * заказчик рассматривает переход на 0–10, и менять придётся только эти два
 * числа — компонент оценки принимает деления снаружи.
 */
export const SCORE_MIN = 1
export const SCORE_MAX = 5

/** Предел из контракта: длиннее бэк вернёт 422. */
export const COMMENT_MAX_LENGTH = 1024

/**
 * Когда показывать опрос.
 *
 * `visits` — сам всплывает, начиная с указанного захода на экран.
 * `manual` — только по кнопке, сам не появляется.
 */
export type SurveyTrigger =
  | { type: 'visits'; route: string; minVisits: number }
  | { type: 'manual' }

export interface SurveyDefinition {
  /** Кодовое имя фичи — то же, что заводится в админке. */
  slug: string
  /** Заголовок модалки. Название из ответа не используем: в данных только
   *  имя фичи, формулировку вопроса хранит приложение. */
  title: string
  subtitle: string
  /** Метка экрана для отчётов. Бэк её не проверяет — набор имён наш. */
  page: string
  trigger: SurveyTrigger
}

/**
 * Опросы, которые приложение умеет показывать, по кодовому имени фичи.
 *
 * Фича заводится в админке заранее, здесь под её слаг добавляется текст и
 * место показа. Незнакомый слаг приложение молча пропускает — показать его
 * всё равно нечем.
 */
export const SURVEYS: readonly SurveyDefinition[] = [
  {
    slug: 'foodpairing',
    title: 'Оцените фудпейринг',
    subtitle: 'Нам важно ваше мнение',
    page: 'flavors',
    // Со второго захода: на первом человек ещё не понял, что это за раздел.
    trigger: { type: 'visits', route: ROUTES.FLAVORS, minVisits: 2 },
  },
  {
    slug: 'profile',
    title: 'Оцените профиль',
    subtitle: 'Нам важно ваше мнение',
    page: 'profile',
    trigger: { type: 'visits', route: ROUTES.PROFILE, minVisits: 2 },
  },
  {
    slug: 'overall',
    title: 'Оцените приложение',
    subtitle: 'Нам важно ваше мнение',
    page: 'profile_button',
    // Только по кнопке: приложение в целом оценивает тот, кто сам захотел.
    trigger: { type: 'manual' },
  },
]

export const getSurvey = (slug: string): SurveyDefinition | undefined =>
  SURVEYS.find(survey => survey.slug === slug)
